import type { Messages } from './en.js'

// Draft translations for UI chrome (Japanese), pending professional review in
// Tolgee.
export const ja: Messages = {
  'common.needHelp': 'お困りですか？',
  'common.continue': '続ける',
  'common.back': '戻る',

  'shell.cookiePolicy': 'Cookie ポリシー',
  'shell.privacyPolicy': 'プライバシーポリシー',
  'shell.cookiePreferences': 'Cookie 設定',
  'shell.language': '言語',

  'login.title': 'ログイン',
  'login.subtitle': 'アカウントに登録されているメールアドレスを使用してください。',
  'login.forgot': 'パスワードをお忘れですか？',
  'login.createAccount': 'アカウントを作成',

  'forgot.title': 'パスワードをリセット',
  'forgot.subtitle': '新しいパスワードを設定するための6桁のコードをメールでお送りします。',
  'forgot.newTitle': '新しいパスワードを設定',
  'forgot.backToSignIn': 'ログインに戻る',

  'consent.message':
    '当サイトの運営のために Cookie を使用し、ご同意いただいた場合は測定と改善にも使用します。',
  'consent.acceptAll': 'すべて同意する',
  'consent.essentialOnly': '必須のみ',

  'common.email': 'メールアドレス',
  'common.password': 'パスワード',
  'common.tryAgain': '再試行',
  'err.tooManyAttempts': '試行回数が多すぎます',
  'err.checkFailed': '確認に失敗しました',
  'err.otpDeliveryFailed': 'コードを送信できませんでした',
  'err.otpLocked': 'コードの誤入力が多すぎます',
  'err.otpExpired': 'このコードは期限切れです',
  'err.countryNotPermitted': 'お住まいの国ではご利用いただけません',
  'err.temporarilyUnavailable': '一時的にご利用いただけません',
  'err.checkAnswers': '回答をご確認ください',
  'err.somethingWrong': '問題が発生しました',

  'step.account': 'アカウント',
  'step.identity': '本人確認',
  'step.compliance': 'コンプライアンス',
  'step.finish': '完了',

  'account.emailTitle': 'アカウントを開設',
  'account.emailSubtitle': 'アドレス確認のため6桁のコードをメールでお送りします。',
  'account.botFailedTitle': 'ボット確認を読み込めませんでした',
  'account.botFailedBody': 'このまま続行できます — 送信時に確認します。',
  'account.send': 'コードを送信',
  'account.sending': '送信中…',
  'account.haveAccount': 'すでにアカウントをお持ちですか？',
  'account.login': 'ログイン',
  'account.otpTitle': 'コードを入力',
  'account.otpSentTo': '{target} に送信しました。',
  'account.otpTargetFallback': 'お客様のメールアドレス',
  'account.escalated': '別のプロバイダーから別のコードを送信しました。',
  'account.startAgain': '最初からやり直す',
  'account.checking': '確認中…',
  'account.verify': '確認',
  'account.resend': 'コードを再送信',
  'account.tryAnotherWay': '受け取れませんでした — 別の方法を試す',
  'account.differentEmail': '別のメールアドレスを使う',
  'account.profileTitle': 'あと少しの情報',
  'account.profileSubtitle': 'これがアカウント設定の最後です。',
  'account.emailReadonlyHint': '先ほど入力したコードで確認済みです。',
  'account.country': '居住国',
  'account.countrySearch': '国を検索',
  'account.phone': '電話番号',
  'account.consentBefore': '次のポリシーに従い、個人情報の収集と利用に同意します：',
  'account.consentAfter': '。また、申請について連絡を受ける場合があることを理解しています。',
  'account.creating': '作成中…',
  'account.existsTitle': 'すでにアカウントをお持ちです',
  'account.signInInstead': '代わりにログイン',

  'partner.add': 'パートナーコードをお持ちですか？',
  'partner.label': 'パートナーコード / Link ID',
  'partner.confirm': 'コードを適用',
  'partner.remove': '削除',
  'partner.close': 'パートナーコード欄を閉じる',
  'partner.referredBy': '紹介者',
  'partner.partnerId': 'パートナーID',
  'partner.country': '国',
  'partner.unavailable': 'このコードを確認できませんでした。もう一度お試しください。',

  'identity.notReadyTitle': '先にアカウントを完了してください',
  'identity.backToStep1': 'ステップ1に戻る',
  'identity.title': '本人確認',
  'identity.subtitle': '取引の前にご本人の確認が法令で求められています。約2分で完了します。',
  'identity.startFailedTitle': '確認を開始できませんでした',
  'identity.step1': 'パスポート、身分証明書、または運転免許証をご用意ください。',
  'identity.step2': '書類を撮影し、その後短い自撮りを行います。',
  'identity.step3': 'ブラウザが求めたらカメラへのアクセスを許可してください — カメラなしでは確認できません。',
  'identity.starting': '開いています…',
  'identity.start': '確認を開始',
  'identity.partnerNote': '確認パートナーへ移動し、すぐにこのページへ戻ります。',
  'identity.inProgress': 'すでに開始済みです。続行すると前回の続きから再開します。',
  'webview.title': 'このページをブラウザで開いてください',
  'webview.cameraWarn': 'カメラは {browser} では通常動作せず、本人確認にはカメラが必要です。',
  'webview.namedBrowser': '{app} の内蔵ブラウザ',
  'webview.thisBrowser': 'このアプリの内蔵ブラウザ',
  'webview.iosInstruction': '共有アイコンをタップし、Open in Safari を選択してください。',
  'webview.openInChrome': 'Chrome で開く',
  'webview.androidInstruction': 'またはメニューから Open in browser を選択してください。',
  'webview.otherInstruction': 'このページのアドレスを通常のブラウザにコピーしてください。',

  'confirm.title': '内容を確認',
  'confirm.subtitle': '書類から入力しました — 正しいか確認し、誤りがあれば修正してください。',
  'confirm.saveFailedTitle': '内容を保存できませんでした',
  'confirm.idOutstandingTitle': '本人確認書類がまだ必要です',
  'confirm.idOutstandingBody':
    '本人確認が完了していないため、以下にお客様の情報をご入力ください。そのまま最後まで進めていただけます — 書類については別途メールでご連絡します。',
  'confirm.firstName': '名',
  'confirm.lastName': '姓',
  'confirm.dob': '生年月日',
  'confirm.whereLive': 'お住まいはどちらですか？',
  'confirm.city': '市区町村',
  'confirm.state': '都道府県 / 州',
  'confirm.saving': '保存中…',

  'compliance.stillCheckingTitle': '本人確認書類を確認中です',
  'compliance.backToVerification': '確認に戻る',
  'compliance.loading': 'アンケートを読み込んでいます…',
  'compliance.loadFailedTitle': 'アンケートを読み込めませんでした',
  'compliance.stillStuck': 'まだ解決しませんか？',
  'compliance.title': '最後にいくつかの質問',
  'compliance.subtitle': '口座開設の前に法令によりこれらの質問が必要です。回答は申請とともに保管されます。',
  'compliance.submitting': '送信中…',
  'compliance.submit': '送信',
  'compliance.oneQuestionLeft': 'あと1問の回答が必要です。',
  'compliance.questionsLeft': 'あと{count}問の回答が必要です。',
  'compliance.saveAnswersFailed': '回答を保存できませんでした',

  'gate.stepToFinishTitle': '先に完了すべきステップがあります',
  'gate.continueWhereLeft': '前回の続きから続ける',

  'done.loadingDocs': '最後の書類を読み込んでいます…',
  'done.loadFailedTitle': '書類を読み込めませんでした',
  'done.tryAgainMoment': '少し待ってから再度お試しください。',
  'done.title': '最後にひとつ',
  'done.readyToSubmit': 'お申し込みを送信する準備ができました。',
  'done.pleaseAccept': '口座開設の前に、これらの書類をお読みのうえ同意してください。',
  'done.agreeAll': '{count}件すべての書類を読み、同意します',
  'done.hideDocs': '書類を隠す',
  'done.showDocs': '{count}件の書類を表示',
  'done.version': 'バージョン {version}',
  'done.finishing': '完了中…',
  'done.finishSignIn': '完了してログイン',
  'done.oneLeft': 'あと1件の書類に同意が必要です。',
  'done.docsLeft': 'あと{count}件の書類に同意が必要です。',
  'done.straightIn': 'そのままアカウントへご案内します — 再度のログインは不要です。',
  'done.completeFailed': 'お申し込みを完了できませんでした',
  'done.acceptEvery': 'すべての書類に同意してください',
  'done.getApps': '取引アプリを入手',
  'done.getAppsSubtitle': '口座開設後は MT5 または KCM Trade アプリで取引します。',
  'done.onComputer': 'パソコンをお使いですか？',
  'done.scanQr': 'QR コードをスキャン',
  'done.scanQrSuffix': 'してスマートフォンにアプリを入手してください。',

  'kyc.approvedTitle': '本人確認が完了しました',
  'kyc.approvedBody': 'ありがとうございます — 一番大変な部分は終わりました。',
  'kyc.reviewTitle': '書類を確認しています',
  'kyc.reviewBody':
    '担当者が確認しています — 通常は数時間で、完了次第すぐにメールでお知らせします。ここで待つ必要はありません。残りを続けて完了してください。',
  'kyc.questions': 'ご不明な点は？',
  'kyc.declinedTitle': '本人確認ができませんでした',
  'kyc.contactPrefix': 'お問い合わせ：',
  'kyc.contactSuffix': '以降は当方で対応します。',
  'kyc.expiredTitle': 'セッションがタイムアウトしました',
  'kyc.expiredBody': '確認セッションは長くは開いていません。やり直しは数分で済みます。',
  'kyc.continueAnyway': '申し込みを続ける',
  'kyc.finishLaterBody':
    '残りのお申し込みは今すぐ完了できます。本人確認書類については別途メールでご連絡し、それまで口座は保留のままとなります。',
  'decline.document_unreadable':
    '書類の写真が不鮮明で読み取れませんでした。明るい場所と平らな面で撮り直すと改善します。',
  'decline.face_mismatch': '自撮りが書類の写真と一致しませんでした。',
  'decline.document_expired': 'ご使用の書類は有効期限が切れています。',
  'decline.other': '自動チェックでは本人確認ができませんでした。',

  'verify.checkFailedTitle': 'ステータスを確認できませんでした',
  'verify.checkFailedBody': '確認は送信されました。このページを再読み込みすると通常は解決します。',
  'verify.refresh': '再読み込み',
  'verify.stillProcessingTitle': 'まだ処理中です',
  'verify.stillProcessingBody':
    '通常より時間がかかっています。書類は送信済みで失われていません — 結果が出次第すぐにメールでお知らせします。',
  'verify.back': '戻る',
  'verify.checkingTitle': '書類を確認しています',
  'verify.checkingBody': '通常は数秒で完了します。このページを閉じないでください。',
  'verify.checkingAria': 'ステータスを確認しています',
  'handoff.receivedTitle': '書類を受け取りました',
  'handoff.receivedBody': 'ありがとうございます — スマートフォンから必要なものはすべて揃いました。',
  'handoff.goBackTitle': 'パソコンに戻ってください',
  'handoff.goBackBody':
    'お申し込みは開始したブラウザで開いたままです。そちらで完了してください — 確認が終わると自動的に進みます。',
  'handoff.closeTab': 'このタブを閉じてかまいません。',
  'handoff.somethingWrong': '何か問題がありますか？',
}
